import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Row, Col, Spin } from 'antd'
import { PayloadAction } from '@reduxjs/toolkit'
import { useForm } from 'antd/lib/form/Form'

import * as Models from '../../../api/model/models'
import { Form, Input, Button, Modal } from '../../common/index'
import styles from './recovery.module.scss'
import './recovery.ant.scss'
import { accountActions } from '../../../store/slices/accountSlice'
import { Title } from '../../common/text'
import useNeedCaptcha from '../../../hooks/useNeedCaptcha'
import { emailRecoveryValidator } from '../../../utils/ant-form-validators'
import { validateMessages } from '../../../utils/constants'

const { Item } = Form

type Props<T> = {
  selectTab: (tab: T) => void
}

const Recovery: FC<Props<TabHeader>> = ({ selectTab }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const [form] = useForm()

  const { needCaptcha, checkCaptchaResponse } = useNeedCaptcha()

  const handleSubmit = async (fields: Models.SendEmailReset) => {
    setLoading(true)
    const response = (await dispatch<unknown>(accountActions.fetchResetPassword(fields))) as PayloadAction<
      unknown,
      string,
      { payload: void; type: string },
      { message: string }
    >
    if (checkCaptchaResponse(response)) {
      setLoading(false)
      form.resetFields()
      return
    }

    if (response.type === 'fetchResetPassword/fulfilled') {
      await dispatch<unknown>(accountActions.fetchLogOut())
      setLoading(false)
      Modal.success({
        content: (
          <>
            <Title level={2}>Успешно!</Title>
            <span>Проверьте e-mail и следуйте инструкциям в письме.</span>
          </>
        ),
        maskClosable: true,
        okButtonProps: {
          style: { display: 'none' },
        },
        afterClose: () => window.location.reload(),
      })
      selectTab('hidden')
      return
    }

    setLoading(false)
  }
  return (
    <>
      <Spin spinning={loading}>
        <Row justify="start" className="form-recovery">
          <Col flex="328px">
            <p className={styles.p}>Введите e-mail, на него мы отправим инструкцию по восстановлению пароля</p>
            <Form
              form={form}
              name="recovery"
              layout="vertical"
              onFinish={handleSubmit}
              validateMessages={validateMessages}
            >
              <Item
                name="email"
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    validator: emailRecoveryValidator,
                  },
                ]}
              >
                <Input autoFocus placeholder={'e-mail'} type="email" />
              </Item>
              {needCaptcha && <Form.Captcha form={form} />}
              <Item className={styles.groupButtons}>
                <Button type="primary" htmlType="submit">
                  ОТПРАВИТЬ
                </Button>
              </Item>
            </Form>
          </Col>
        </Row>
      </Spin>
    </>
  )
}

export default Recovery
